// extracted by mini-css-extract-plugin
export var dropdownButton = "_33-0";
export var fullWidthDropdownButton = "_33-1";
export var icon = "_33-3";
export var iconPlaceholder = "_33-2";
export var shortcutContainer = "_33-4";